import React from 'react';
import AuthForm from './auth-form.jsx';
import AuthShell from './auth-shell.jsx';

function AuthClassicResetPassword() {
	return <AuthShell variant="classic"><AuthForm variant="classic" mode="reset-password" /></AuthShell>;
}

export default AuthClassicResetPassword;
